<section class="c-item-registration">

    <div class="grid">

        <!-- Add New Document Card -->
        <div *ngIf="buttonAddNewDocument" class="col-12">
            <div class="card">
                <div class="flex justify-content-between">
                    <h5 class="card-title">
                        <i class="pi pi-user mr-2"></i>
                        Usuário: <strong class="ml-2">{{scPersonName}}</strong>
                    </h5>
                    <button pButton pRipple icon="pi pi-plus"
                        class="p-button-info  font-medium"
                        [label]="'Adicionar Novo Documento'"
                        (click)="addNewDocument()"></button>
                </div>
            </div>
        </div>
        <!-- Upload Form Card -->
        <div *ngIf="!buttonAddNewDocument" class="col-12">
            <div class="card">
                <h5 class="card-title mb-4">
                    <i class="pi pi-cloud-upload mr-2"></i>
                    Novo Documento
                </h5>

                <div class="grid">
                    <div class="col-12 md:col-12 lg:col-4">
                        <label class="block mb-2 font-semibold">
                            <i class="pi pi-file mr-2"></i>
                            Selecionar Arquivos
                        </label>
                        <p-fileUpload #fileUpload
                            [disabled]="scArchiveTypeId == null || scArchiveTypeId == '00000000-0000-0000-0000-000000000000'"
                            mode="basic"
                            chooseLabel="Adicionar"
                            name="files[]"
                            accept="image/png,image/jpeg,image/webp,image/bmp,application/pdf,.png,.jpg,.jpeg,.webp,.bmp,.pdf"
                            maxFileSize="1000000"
                            (uploadHandler)="onUpload($event)"
                            [auto]="true"
                            [multiple]="true"
                            customUpload="true"
                            chooseStyleClass="p-button-info w-full">
                            <ng-template pTemplate="content">
                                <ul *ngIf="listPersonFile.length">
                                    <li *ngFor="let file of listPersonFile">
                                        {{ file.name }} - {{ file.size }} bytes
                                    </li>
                                </ul>
                            </ng-template>
                        </p-fileUpload>
                    </div>

                    <div class="col-12 md:col-12 lg:col-8">
                        <label class="block mb-2 font-semibold">
                            <i class="pi pi-tag mr-2"></i>
                            Tipo Documento
                        </label>
                        <sf-dropdown-generic
                            [list]="docTypeList"
                            (selectedItemOutput)="reciverFeedbackDocType($event)"
                            [id]="scArchiveTypeId"
                            class="w-full">
                        </sf-dropdown-generic>
                        <small class="p-invalid block mt-1" *ngIf="getFiledValidation(!scArchiveTypeId)"
                            translate>validation_errors.required_field</small>
                    </div>

                    <div class="col-12">
                        <div class="flex justify-content-end gap-2 mt-3">
                            <button pButton pRipple icon="pi pi-times"
                                class="p-button-danger font-medium"
                                [label]="'button.cancel' | translate"
                                (click)="cancel();"></button>
                            <button pButton pRipple icon="pi pi-save"
                                class="p-button-success font-medium"
                                [label]="'button.save' | translate"
                                (click)="save();"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Go Back Button -->
        <div *ngIf="goBackVisible" class="col-12">
            <div class="card">
                <p-button icon="pi pi-arrow-left"
                    [style]="{'width': '100%'}"
                    styleClass="p-button-info"
                    label="Dados Pessoais - {{scPersonName}}"
                    (click)="onGoBack()"></p-button>
            </div>
        </div>

        <!-- Selected Files Preview Card -->
        <div class="col-12" *ngIf="uploadedFiles.length > 0">
            <div class="card">
                <h5 class="card-title mb-3">
                    <i class="pi pi-images mr-2"></i>
                    Arquivos Selecionados ({{uploadedFiles.length}})
                </h5>
                <div class="flex flex-wrap gap-2 mb-3">
                    <span *ngFor="let file of uploadedFiles; let i = index"
                        class="p-tag p-tag-info">
                        {{file.name}}
                    </span>
                </div>
                <div class="flex justify-content-center">
                    <img [src]="uploadedFiles[0].objectURL.changingThisBreaksApplicationSecurity"
                        class="preview-image">
                </div>
            </div>
        </div>

        <!-- Document Carousel Card -->
        <div [class]="fullScreen == true ? 'col-12 md:col-8 lg:col-8' : 'col-12'">
            <div class="card">
                <div *ngIf="listPersonFile.length > 0 && buttonAddNewDocument">
                    <p-galleria *ngIf="loadFiles"
                        [(visible)]="loadFiles"
                        #galleria
                        [(value)]="listPersonFile"
                        [(activeIndex)]="activeIndex"
                        [numVisible]="5"
                        [showThumbnails]="showThumbnails"
                        [showItemNavigators]="true"
                        [showItemNavigatorsOnHover]="true"
                        [circular]="true"
                        [autoPlay]="false"
                        [transitionInterval]="3000"
                        [containerStyle]="{'width':'100%'}"
                        [containerClass]="galleriaClass()">
                        <ng-template pTemplate="item" let-item>
                            <img [src]="item.pictureUri" class="galleria-image" />
                        </ng-template>
                        <ng-template *ngIf="buttonAddNewDocument" pTemplate="thumbnail" let-item>
                            <div class="grid grid-nogutter justify-content-center">
                                <img height="50" width="50" [src]="item.pictureUri" style="display: block;" />
                            </div>
                        </ng-template>
                        <ng-template pTemplate="footer" let-item>
                            <div class="custom-galleria-footer">
                                <button type="button" pButton icon="pi pi-list" (click)="onThumbnailButtonClick()"></button>
                                <span *ngIf="listPersonFile" class="title-container">
                                    <span>{{ activeIndex + 1 }}/{{ listPersonFile.length }}</span>
                                    <span class="title">{{ listPersonFile[activeIndex].createdAt | date : 'dd/MM/yyyy HH:mm:ss' }} - {{listPersonFile[activeIndex].archiveType}}</span>
                                    <span>{{ listPersonFile[activeIndex].userName }}</span>
                                </span>
                                <button type="button" pButton [icon]="fullScreenIcon()" (click)="toggleFullScreen()"
                                    class="fullscreen-button"></button>
                            </div>
                        </ng-template>
                    </p-galleria>
                </div>

                <div *ngIf="listPersonFile.length == 0" class="text-center p-4">
                    <i class="pi pi-inbox text-4xl text-400 mb-3"></i>
                    <p class="text-500" translate>label.empt</p>
                </div>
            </div>
        </div>

        <!-- Document List Card -->
        <div *ngIf="buttonAddNewDocument" [class]="fullScreen == true ? 'col-12 md:col-4 lg:col-4' : 'col-12'">
            <div class="card document-list-card">
                <h5 class="card-title mb-3">
                    <i class="pi pi-list mr-2"></i>
                    Relação de Documentos
                </h5>
                <div class="document-list-container" >
                    <div *ngFor="let item of listPersonFile; let i = index"
                        class="document-list-item"
                        [class.active]="activeIndex === i" (click)="selectDocument(i);">
                        <div class="flex align-items-center gap-2 cursor-pointer" >
                            <img [src]="item.pictureUri"
                                class="document-thumbnail"
                                width="40"
                                height="40">
                            <div class="flex-1">
                                <div class="font-semibold text-sm">{{item.archiveType}}</div>
                                <div class="text-xs text-500">
                                    {{ item.createdAt | date : 'dd/MM/yyyy' }}
                                </div>
                            </div>
                        </div>
                        <div class="flex align-items-center">
                            <button *ngIf="canDelete"
                                pButton
                                pRipple
                                icon="pi pi-times"
                                class="p-button-danger p-button-text p-button-sm"
                                (click)="deleteFile(item.id, item.scCompanyId, item.scPersonId, item.archiveType);"
                                pTooltip="Excluir documento"
                                tooltipPosition="left">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="fileZoomVisible" class="overlay">
        <p-dialog header="Zoom" [(visible)]="fileZoomVisible" [style]="{width: '80vw', height: '80vh'}">
            <div class="card flex justify-content-center">
                <p-image [src]="this.fileZoomUrl" [preview]="true" alt="Image" width="250">
                    <ng-template pTemplate="indicator">
                        <i class="pi pi-check"></i>
                    </ng-template>
                </p-image>
            </div>
        </p-dialog>
    </div>
</section>

<p-confirmDialog key="message.confirm_delete.file" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
